import { render, staticRenderFns } from "./baseButton.vue?vue&type=template&id=f68077f6&"
import script from "./baseButton.vue?vue&type=script&lang=js&"
export * from "./baseButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports